import { Box, FormControl, MenuItem, Select } from "@material-ui/core";
import React from "react";
import { LEAD_TYPES } from "../../../constants/CoreConstants";
import {
  AddContactModalV2Styles,
  BasicInputSelect
} from "./AddContactModalV2Styles";
import BasicFormControlWithLabelV2 from "../../custom/BasicFormControlWithLabelV2";

const LeadType = ({ leadType, onChange }) => {
  const { menuItem } = AddContactModalV2Styles();
  const placeholderColor = "rgb(8 40 82 / 44%)";
  const activeColor = "#36454F";

  return (
    <Box>
      <FormControl fullWidth sx={{ marginLeft: 2 }}>
          <BasicFormControlWithLabelV2
              label={'Lead Type'}
              fullWidth
              component={
                  <Select
                      value={leadType || "default"}
                      defaultValue={"default"}
                      name="leadType"
                      onChange={(event) => onChange("lead_type", event.target.value)}
                      input={<BasicInputSelect   style={{ color: `${!leadType ? placeholderColor : activeColor}` }}/>}
                      inputProps={{ "aria-label": "Without label" }}
                      MenuProps={{
                          anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left",
                          },
                          transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                          },
                          getContentAnchorEl: null,
                      }}
                  >
                      <MenuItem value="default" disabled className={`dropdownhelper-menuitem-class ${menuItem}`}>
                          Lead Type
                      </MenuItem>

                      {LEAD_TYPES.map((leadType) => (
                          <MenuItem
                              key={leadType.value}
                              value={leadType.value}
                              className={`dropdownhelper-menuitem-class ${menuItem}`}
                          >
                              {leadType.label}
                          </MenuItem>
                      ))}
                  </Select>
              }
              sx={{
                  '& .MuiInputBase-root': {
                      marginTop: 0,
                  },
                  '& .MuiInputBase-input': {
                      border: 'none !important'
                  }
              }}
          />
      </FormControl>
    </Box>
  );
};

export default LeadType;
